module.exports = __webpack_public_path__ + "assets/2eabac3ed845437dce712fffdefc3dc7.mp4";